import Vue from "vue";
import VueRouter from "vue-router";
import ynott from "../views/ynott/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "ynott",
    component: ynott,
  },
  {
    path: "/works",
    name: "works",
    component: function () {
      return import(/* webpackChunkName: "works" */ "../views/works/index.vue");
    },
  },
  {
    path: "/worksInfo",
    name: "worksInfo",
    component: function () {
      return import(/* webpackChunkName: "worksInfo" */ "../views/works_info/index.vue");
    },
  },
  {
    path: "/newsInfo",
    name: "newsInfo",
    component: function () {
      return import(/* webpackChunkName: "worksInfo" */ "../views/news_info/index.vue");
    },
  },
  {
    path: "/flow",
    name: "flow",
    component: function () {
      return import(/* webpackChunkName: "worksInfo" */ "../views/flow/index.vue");
    },
  },
  {
    path: "/about",
    name: "about",
    component: function () {
      return import(/* webpackChunkName: "aboutUs" */ "../views/about_us/index.vue");
    },
  },
  {
    path: "/news",
    name: "news",
    component: function () {
      return import(/* webpackChunkName: "aboutUs" */ "../views/news/index.vue");
    },
  },
  {
    path: "/contact",
    name: "contact",
    component: function () {
      return import(/* webpackChunkName: "aboutUs" */ "../views/contact/index.vue");
    },
  },
  {
    path: "/timeAxis",
    name: "timeAxis",
    component: function () {
      return import(/* webpackChunkName: "timeAxis" */ "../views/time_axis/index.vue");
    },
  },
];

const router = new VueRouter({
  // mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
});

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default router;
